import axios from 'axios'
import Cookies from 'js-cookie'
import useSWR from 'swr'

import { PAGE_SIZE } from '../../../config/consts'
import { formatDateToStr } from '../../../utils/display'

interface GetStoreVisitCountStoreRankRequest {
  serviceId: string
  fromDate: Date | null // '2021-01-01'
  toDate: Date | null // '2021-01-02'
  limit?: number | null
  offset?: number | null
  sortTarget?: number | null
  isAsc?: boolean | null
}

interface GetStoreVisitCountStoreRankResponse {
  statusCode: number
  statusMessage: string
  storeVisitCountStoreRankDatas: {
    siteId: number
    siteName: string
    storeVisitCountUUDataRange: number
    storeVisitCount: number
    avgDwellTime: number
  }[]
  totalCount: number
}

const useGetStoreVisitCountStoreRank = ({
  serviceId,
  fromDate,
  toDate,
  limit,
  offset,
  sortTarget,
  isAsc,
}: GetStoreVisitCountStoreRankRequest) => {
  const accessToken = Cookies.get('LoginToken')
  const fetcher = (url: string): Promise<GetStoreVisitCountStoreRankResponse> => axios.get(url).then((res) => res.data)

  const url = new URL(`${process.env.REACT_APP_CITRUS_API_DOMAIN}/api/getStoreVisitCountStoreRank`)
  // common params
  url.searchParams.append('accessToken', accessToken ?? '')
  url.searchParams.append('serviceId', serviceId)
  url.searchParams.append('fromDate', formatDateToStr(fromDate))
  url.searchParams.append('toDate', formatDateToStr(toDate))

  // sort params
  url.searchParams.append('limit', limit ? limit.toString() : PAGE_SIZE.toString())
  url.searchParams.append('offset', offset ? offset.toString() : '0')
  url.searchParams.append('sortTarget', sortTarget ? (sortTarget + 1).toString() : '0') // not 0-indexed
  url.searchParams.append('isAsc', isAsc ? 'true' : 'false')

  const { data, isLoading, mutate } = useSWR(
    () => accessToken && serviceId && fromDate && toDate && url.href,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
    },
  )

  return {
    stampCampaignRankStoreRank: data,
    stampCampaignRankStoreRankLoading: isLoading,
    stampCampaignRankStoreRankMutate: mutate,
  }
}

export default useGetStoreVisitCountStoreRank
